<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <holiday-edit-form @on-submit="onHolidayEditSubmit"></holiday-edit-form>
    </div>
  </div>
</template>
<script>
import HolidayEditForm from "./HolidayEditForm.vue";

export default {
  components: {
    HolidayEditForm
  },
  data() {
    return {
      holidayEditModel: {}
    };
  },
  methods: {
    onHolidayEditSubmit(model) {
      this.holidayEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'holidayss/' + this.holidayEditModel.id, Object.assign(this.holidayEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
